import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navigation } from './components/Navigation';
import { HomePage } from './pages/HomePage';
import { ApplyPage } from './pages/ApplyPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="grain-overlay" data-id="element-1" />
      <Navigation data-id="element-2" />
      <Routes data-id="element-3">
        <Route path="/" element={<HomePage data-id="element-5" />} data-id="element-4" />
        <Route path="/apply" element={<ApplyPage data-id="element-7" />} data-id="element-6" />
      </Routes>
    </BrowserRouter>;
}